export const orderArray = (data, field) => {
  return data.sort((item, nextItem) =>
    String(item[field]).localeCompare(String(nextItem[field]))
  );
};

export const orderArrayV2 = (data=[], key=null, reverse = false) => {
  if(!data) return []
  if (typeof data[0] === 'string') {
    return reverse ? data.sort().reverse() : data.sort();
  } else {
    return data.sort((a, b) => {
      return reverse
        ? a[key] > b[key] ? -1 : 1
        : a[key] < b[key] ? -1 : 1;
    });
  }
};

